<template>
	<div>
		<NavBar :groupInfo="groupInfo" :demoInfo="demoInfo" active="groups" />
		<v-layout row wrap style = "background:url('https://i.postimg.cc/NGps0dqN/headline.png');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Our Teams</div>
                <div class = "display-1 mb-4" style="color:grey">闻道有先后 术业有专攻</div>
            </v-flex>
        </v-layout>
        
        <v-layout row wrap class = "pt-5 groups-container" >
            <v-flex xs12 sm12 md1></v-flex>
            <v-flex xs12 sm12 md10>
                <v-timeline dense>
                    <template v-for="(group,index) in groupInfo">
                        <v-timeline-item :key="index" :color="group.logan" large right :id="group.logan">
                            <v-card class="elevation-2" >
                                <div>
                                    <v-layout align-center fill-height class = "py-2 group-layout">        
                                        <v-flex xs12 sm5 class="group-image-flex">
                                            <v-img :src="group.picture"  height="400px" class="ml-3 group-image" lazy contain>
                                                <template v-slot:placeholder>
                                                    <v-layout fill-height align-center justify-center ma-0>
                                                        <v-progress-circular indeterminate :color="group.logan"></v-progress-circular>
                                                    </v-layout>
                                                </template>
                                            </v-img>
                                        </v-flex>
                                        <v-flex class="px-5 group-content-flex" xs12 sm7 >
                                            <div class="text-xs-center my-2" :style="{color:$color.primary,fontFamily:'ProximaNova !important',fontSize:group.name.length > 35 ? '2.0rem':'2.3rem'}">{{group.name}}</div>
                                            <div class="text-xs-center my-2" :style="{color:$color.primary,fontFamily:'BenMo !important',fontSize:'1.9rem'}">{{group.intro}}</div>

                                            <v-divider></v-divider>
                                            <div class="text-xs-left my-2 scroll-y" style="font-size:1.3rem;max-height:30vh;font-family:ProximaNova">{{group.description}}</div>
                                            <v-divider class = "mb-3"></v-divider>
                                            <v-layout row left>
                                                <div style="text-align:left;">
                                                    <v-chip class = "text-xs-left" outline :color="$color.activate" v-for="(keyword,kk_id) in group.keywords" :key="kk_id">
                                                        <strong>{{ keyword }}</strong>&nbsp;
                                                    </v-chip>
                                                </div>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </div>
                                <div>
                                    <v-layout>
                                        <v-btn flat style="font-size:2.0rem !important;">
                                            <v-icon left style="font-size:2.5rem !important;">people</v-icon>Members
                                        </v-btn>
                                    </v-layout>
                                    <v-divider ></v-divider>
                                     <v-layout>
                                        <div class="avatar-scrolling ma-4 scroll-x">
                                            <div justify-center column v-for="(a_item,a_index) in group.members" class="mx-3 avatar-el text-xs-center" :key="a_index" >
                                                <v-avatar  size="10vh" color="grey lighten-4" >
                                                    <v-img :src="a_item.picture == '' ? 'https://i.postimg.cc/GpKN1pgY/2.jpg' : a_item.picture " alt="avatar">
                                                        <template v-slot:placeholder>
                                                            <v-layout fill-height align-center justify-center ma-0>
                                                                <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                            </v-layout>
                                                        </template>
                                                    </v-img>
                                                </v-avatar>
                                                <div class = "avatar-el my-2">
                                                    {{a_item.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card>
                           
                        </v-timeline-item>
                    </template>
                </v-timeline>

            </v-flex>
            <v-flex xs12 sm12 md1></v-flex>
        </v-layout>

	</div>
</template>

<script>
import NavBar from './NavBar'
export default {
  name: 'Groups',
  components:{NavBar},
  data() {
    return {
		groupInfo:[{name:"",logan:"red",members:[{name:"",picture:""}],picture:"",publications:[],keywords:[],id:0,intro:"",description:""}],
		people:[{name:"Gus Xia",avatar:"https://i.postimg.cc/Nj1SpD1d/1.jpg",link:"http://www.baidu.com"},
                {name:"Ziyu Wang",avatar:"https://i.postimg.cc/GpKN1pgY/2.jpg",link:"http://www.baidu.com"},
                {name:"Yiyi Zhang",avatar:"https://i.postimg.cc/hjGY4qNY/3.jpg",link:"http://www.baidu.com"},
                {name:"Ruihan Yang",avatar:"https://i.postimg.cc/J4JRCbNk/4.jpg",link:"http://www.baidu.com"},
                {name:"Junyan Jiang",avatar:"https://i.postimg.cc/ZYXJQfdm/5.jpg",link:"http://www.baidu.com"},
                {name:"Ke Chen",avatar:"https://i.postimg.cc/MHC3YfXk/6.jpg",link:"http://www.baidu.com"},
                {name:"Yixiao Zhang",avatar:"https://i.postimg.cc/BZjqMWtN/7.jpg",link:"http://www.baidu.com"},
                {name:"houze Liu",avatar:"https://i.postimg.cc/0QHBbBsy/8.jpg",link:"http://www.baidu.com"},
                {name:"Dingsu Wang",avatar:"https://i.postimg.cc/nrjw7GFY/9.jpg",link:"http://www.baidu.com"},
                {name:"Tianyao Chen",avatar:"https://i.postimg.cc/T36fdp0H/10.jpg",link:"http://www.baidu.com"},
                {name:"Ruitang Chen",avatar:"https://i.postimg.cc/jS4KLtkq/11.jpg",link:"http://www.baidu.com"},
                {name:"Xianbin Gu",avatar:"https://i.postimg.cc/1zWQrMQL/12.jpg",link:"http://www.baidu.com"},
                {name:"Yian Zhang",avatar:"https://i.postimg.cc/Rhtx9BHB/13.jpg",link:"http://www.baidu.com"}
                ],
        tempLogan:undefined,
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]

    }
  },
  mounted() {
      this.getRouterData()
      this.getGroupsInfo()
  },
  props: {
    msg: String
  },
  methods: {
    getRouterData:function() {
        this.tempLogan = this.$route.params.logan
    },
    getGroupsInfo:async function() {
        let that = this
        await this.$axios.get("/group/id/list").then(function(res) {
            let resdata = res.data
            that.groupInfo = []
            for(let i in resdata) {
                let temp = resdata[i]
                temp.logan = resdata[i].color
                that.groupInfo.push(temp)
            }
           
        }).catch(function() {
            // Error loading group info
        })
        if(typeof(that.tempLogan) != undefined) {
            this.$vuetify.goTo('#' + that.tempLogan)
        }
    },
    switchToPage:function(url) {
		window.location.href=url
	},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.test-class {
    height:auto !important;
}
.limit__height__class .v-list__tile {
    height: auto !important;
}
.limit-logan-offset .v-tooltip__content {
    top:1px !important;
}

.scroll-y { 
    -ms-overflow-style:none;
}
.scroll-y:hover { 
    -ms-overflow-style:-ms-autohiding-scrollbar;
}
.scroll-y::-webkit-scrollbar { 
    width: 0.5vw;
    height: 1px;
    display: none;
}
.scroll-y:hover::-webkit-scrollbar { 
    display: flex;
}
.scroll-y::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}


.avatar-scrolling {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style:none;
    scrollbar-face-color: #657C88;
    transition: all 0.5s;
}
.avatar-scrolling:hover {
    /* opacity: 1; */
    -ms-overflow-style:-ms-autohiding-scrollbar;
    transition: all 0.5s;
}
.avatar-scrolling::-webkit-scrollbar {
    width: 0;
    height: 0;
} 
.avatar-scrolling:hover::-webkit-scrollbar {
    width: 1px;
    height: 0.5vh; 
} 
.avatar-scrolling::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}
.avatar-el {
    display:flex;
    flex-flow:column;
}
.groups-container {
    padding-left: 12px;
    padding-right: 12px;
}
@media (max-width: 960px) {
    .group-layout {
        flex-direction: column !important;
        margin-left: 12px !important;
        margin-right: 12px !important;
    }
    .group-image-flex {
        order: 1 !important;
        width: 100% !important;
        margin-bottom: 16px !important;
        padding: 0 !important;
    }
    .group-content-flex {
        order: 2 !important;
        width: 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .group-image {
        margin-left: 0 !important;
        width: 100% !important;
        height: auto !important;
        max-height: 300px !important;
    }
    .group-image .v-responsive {
        padding-bottom: 0 !important;
    }
    .group-image .v-image__image {
        object-fit: contain !important;
    }
}
@media (max-width: 600px) {
    .group-layout {
        margin-left: 8px !important;
        margin-right: 8px !important;
    }
    .group-image {
        max-height: 250px !important;
    }
}
@media (max-width: 600px) {
    .groups-container {
        padding-left: 8px;
        padding-right: 8px;
    }
}
</style>
